<template>
  <section v-if="!isPageLoading" class="home-page">
    <FeaturedCoursesSlider />
    <LearningAreasList v-if="categories" :categories="categories" />
    <article class="carousels">
      <CarouselsByMetrics
        :isMobile="isMobile"
        :presenters="presenters"
        :popularCourses="popularCourses"
        :newCourses="newCourses"
        :trendingCourses="trendingCourses"
        :windowWidth="windowWidth"
      />
      <CarouselsByTags
        :isMobile="isMobile"
        :presenters="presenters"
        :isCordova="isCordova"
      />
    </article>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import FeaturedCoursesSlider from '@/components/home-page/FeaturedCoursesSlider.vue'
import LearningAreasList from '@/components/home-page/LearningAreasList.vue'
import CarouselsByMetrics from '@/components/home-page/CarouselsByMetrics.vue'
import CarouselsByTags from '@/components/home-page/CarouselsByTags.vue'

export default {
  name: 'Home',
  data() {
    return {
      windowWidth: window.innerWidth,
      isMobile: false,
    }
  },
  components: {
    FeaturedCoursesSlider,
    LearningAreasList,
    CarouselsByMetrics,
    CarouselsByTags,
  },
  computed: {
    ...mapGetters({
      isPageLoading: 'app/isPageLoading',
      presenters: 'presenters/presenters',
      popularCourses: 'courses/popular',
      trendingCourses: 'courses/trending',
      newCourses: 'courses/newCourses',
      categories: 'categories/categories',
      isCordova: 'app/isCordova',
      isAuthenticated: 'auth/isAuthenticated',
      userId: 'auth/userId',
    }),
  },
  watch: {
    windowWidth(width) {
      this.isMobile = width <= 768
    },
  },
  async created() {
    this.$store.dispatch('app/setIsPageLoading', true)
    await this.$store.dispatch('courses/getPopularCourses', 21)
    await this.$store.dispatch('courses/getTrendingCourses', 20)
    await this.$store.dispatch('courses/getNewCourses', 10)
    this.$store.dispatch('app/setIsPageLoading', false)
    if (this.isAuthenticated && this.userId) {
      await this.$store.dispatch('user/getUserActiveCourses', this.userId)
    }
  },
  mounted() {
    this.isMobile = window.innerWidth <= 768
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
}
</script>

<style lang="scss" scoped>
.home-page {
  .carousels {
    padding-left: 20px;
  }
  @include desktop {
    .carousels {
      padding-left: 40px;
    }
  }
}
</style>
